import ModalPanelController from "./modal_panel_controller"

export default class extends ModalPanelController {}
